import { render, staticRenderFns } from "./TrackDetail.vue?vue&type=template&id=360c1306&scoped=true&"
import script from "./TrackDetail.vue?vue&type=script&lang=js&"
export * from "./TrackDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrackDetail.vue?vue&type=style&index=0&id=360c1306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360c1306",
  null
  
)

export default component.exports